module.exports = __webpack_public_path__ + "img/profile-bg.fc3e4207.jpg";